import { jsx as _jsx } from "react/jsx-runtime";
import * as react from "react";
import "../../assets/styles/components/log.scss";
export var LogLevel;
(function (LogLevel) {
    LogLevel["Log"] = "log";
    LogLevel["Warn"] = "warn";
    LogLevel["Error"] = "error";
})(LogLevel || (LogLevel = {}));
export class LogEntry {
    constructor(message, level) {
        this.message = message;
        this.level = level;
        this.time = new Date();
    }
}
export class LogComponent extends react.Component {
    constructor(props) {
        super(props);
        this.state = { logs: [] };
        this._logConsoleRef = react.createRef();
    }
    componentDidMount() {
        this.props.globalState.onLogRequiredObservable.add((log) => {
            const currentLogs = this.state.logs;
            currentLogs.push(log);
            this.setState({ logs: currentLogs });
        });
    }
    componentDidUpdate() {
        if (!this._logConsoleRef.current) {
            return;
        }
        this._logConsoleRef.current.scrollTop = this._logConsoleRef.current.scrollHeight;
    }
    render() {
        return (_jsx("div", { id: "sfe-log-console", ref: this._logConsoleRef, children: this.state.logs.map((l, i) => {
                return (_jsx("div", { className: "log " + l.level, children: l.time.getHours() +
                        ":" +
                        l.time.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 }) +
                        ":" +
                        l.time.getSeconds().toLocaleString(undefined, { minimumIntegerDigits: 2 }) +
                        ": " +
                        l.message }, i));
            }) }));
    }
}
//# sourceMappingURL=logComponent.js.map